import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  Field,
  reduxForm,
} from 'redux-form';
import { Card, CardBody, Col } from 'reactstrap';
import renderSelectField from '../../../../shared/components/form/Select';
import setPropsAsInitialValues from '../../../../helpers/setPropsAsInitialValues';
import validate from './validate';

class StudentSubjectFilterForm extends PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    onFilterChanges: PropTypes.func.isRequired,
    onFilter: PropTypes.func.isRequired,
    periodos: PropTypes.arrayOf(PropTypes.shape({})),
    carreras: PropTypes.arrayOf(PropTypes.shape({})),
    materias: PropTypes.arrayOf(PropTypes.shape({})),
    semestres: PropTypes.arrayOf(PropTypes.shape({})),
  }

  static defaultProps = {
    periodos: [],
    carreras: [],
    materias: [],
    semestres: [],
  }

  onDataTableClearFilters = () => {
    const { pageSize } = this.state;
    this.updateExamsTable(1, pageSize, {});
  };

  render() {
    const {
      handleSubmit,
      materias,
      carreras,
      periodos,
      semestres,
      onFilterChanges,
      onFilter,
    } = this.props;

    return (
      <Col md={12} lg={12}>
        <Card>
          <CardBody>
            <Form className="form" onSubmit={handleSubmit}>
              <Col md={3} lx={6}>
                <div className="form__form-group">
                  <span className="form__form-group-label">Periodo</span>
                  <div className="form__form-group-field">
                    <Field
                      name="periodo"
                      component={renderSelectField}
                      placeholder="Periodo"
                      autoComplete="false"
                      options={periodos}
                      onChange={v => onFilterChanges('periodo', 'periodoId', v)}
                    />
                  </div>
                </div>
              </Col>
              <Col md={3} lx={6}>
                <div className="form__form-group">
                  <span className="form__form-group-label">Carrera</span>
                  <div className="form__form-group-field">
                    <Field
                      name="carrera"
                      component={renderSelectField}
                      placeholder="Carrera"
                      autoComplete="false"
                      options={carreras}
                      onChange={v => onFilterChanges('carrera', 'carreraId', v)}
                    />
                  </div>
                </div>
              </Col>
              <Col md={3} lx={6}>
                <div className="form__form-group">
                  <span className="form__form-group-label">Semestre</span>
                  <div className="form__form-group-field">
                    <Field
                      name="semestre"
                      component={renderSelectField}
                      placeholder="Semestre"
                      autoComplete="false"
                      options={semestres}
                      onChange={v => onFilterChanges('semestre', 'semestreId', v)}
                    />
                  </div>
                </div>
              </Col>
              <Col md={3} lx={6}>
                <div className="form__form-group">
                  <span className="form__form-group-label">Materia</span>
                  <div className="form__form-group-field required">
                    <Field
                      name="materia"
                      component={renderSelectField}
                      placeholder="Materia"
                      autoComplete="false"
                      options={materias}
                      onChange={v => onFilterChanges('materia', 'materiaId', v)}
                    />
                  </div>
                </div>
              </Col>
              <Col md={3} lx={6}>
                <div className="form__form-group">
                  <div className="form__form-group-field">
                    <button
                      className="btn btn-primary"
                      type="button"
                      onClick={onFilter}
                    >
                      Filtrar
                    </button>
                  </div>
                </div>
              </Col>
            </Form>
          </CardBody>
        </Card>
      </Col>
    );
  }
}

const ReduxStudentFilterForm = reduxForm({
  form: 'StudentFilterForm',
  enableReinitialize: true,
  validate,
})(StudentSubjectFilterForm);

export default setPropsAsInitialValues(ReduxStudentFilterForm);
